import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Tabbar from "../../assets/tabbar-ios.png";
import TabbarServices from "../../assets/tabbar-ios-services.png";

import AccountImage from "../../assets/account.png";
import AccountLogoIcons from "../../assets/account-logo-icons.png";
import AccountIcons from "../../assets/account-icons.png";
import AccountLogo from "../../assets/account-logo.png";
import AccountImageLoyalty from "../../assets/account-loyalty.png";
import AccountIconsLoyalty from "../../assets/account-icons-loyalty.png";
import AccountLogoIconsLoyalty from "../../assets/account-logo-icons-loyalty.png";
import AccountLogoLoyalty from "../../assets/account-logo-loyalty.png";

import AccountServiceImage from "../../assets/accountService.png";
import AccountServiceIcons from "../../assets/accountService-icons.png";
import AccountServiceLogoIcons from "../../assets/accountService-logo-icons.png";
import AccountServiceLogo from "../../assets/accountService-logo.png";
import AccountServiceLogoIconsLoyalty from "../../assets/accountService-logo-icons-loyalty.png";
import AccountServiceIconsLoyalty from "../../assets/accountService-icons-loyalty.png";
import AccountServiceLoyalty from "../../assets/accountService-loyalty.png";
import AccountServiceLogoLoyalty from "../../assets/accountService-logo-loyalty.png";

import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { CircularProgress } from "@mui/material";
import { UserContext } from "../../context/UserContext";

import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";

import ComingSoon from "../../components/ComingSoon/ComingSoon";

const useStyles = makeStyles({
	iphoneContainer: {
		"& *": {
			userDrag: "none",
		},
	},
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardPageInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardOptions: {
		display: "flex",
		flexDirection: "column",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
});

const logins = [
	{
		value: "login1",
		label: (
			<>
				<b>Style 1</b>:
			</>
		),
	},
	{
		value: "login2",
		label: (
			<>
				<b>Style 2</b>:
			</>
		),
	},
];

export default function UserContent({ drawerWidth }) {
	const classes = useStyles();
	const { user } = useContext(UserContext);

	const services = user.app.appType === "Services";
	const { t } = useTranslation();

	const alert = useAlert();

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />

			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{
								fontSize: 14,
								borderBottom: "1px solid #f0f0f0",
								minHeight: "35px",
								marginBottom: "20px",
								marginLeft: "-20px",
								marginRight: "-20px",
								padding: "0px 20px 20px",
							}}
							color="text.secondary"
							gutterBottom
						>
							{t("userContent.title")}
						</Typography>
						<Box
							className={classes.cardPageInfo}
							sx={{
								flexFlow: {
									xs: "column-reverse",
									sm: "column-reverse",
									md: "row",
								},
							}}
						>
							<ComingSoon />
						</Box>
					</CardContent>
				</>
			</Card>
		</Box>
	);
}
